import React from "react";
import { Skeleton } from "@material-ui/lab";
import { makeStyles, Theme } from "@material-ui/core";

const FOOTER_HEIGHT = 85;

const useStyles = makeStyles<Theme, { hasActions: boolean }>((theme) => ({
  activityList: ({ hasActions }) => ({
    padding: 10,
    [theme.breakpoints.up("lg")]: {
      padding: 15,
      // backgroundColor: "#eee",
    },
    // boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    // border: "1px solid #ddd",
    // borderRadius: 3,
    // borderLeft: "1px solid #ddd",
    // border: "1px solid red;",
    // top: -1,
    //position: "relative",
    height: `calc(100% - ${hasActions ? FOOTER_HEIGHT : 0}px)`,
    overflow: "scroll",
    overflowX: "hidden",
    // "&::-ms-overflow-style": "none" /* IE and Edge */,
    // scrollbarWidth: "none" /* Firefox */,
    // "&::-webkit-scrollbar": {
    //   width: "0px",
    //   background: "transparent",
    //   display: "none",
    // },
  }),
  skeleton: ({ hasActions }) => ({
    height: `calc(100% - ${hasActions ? FOOTER_HEIGHT : 0}px)`,
  }),
}));

export type ScrollableAreaTabProps = {
  hasActions?: boolean;
  scrollDataTest?: string;
};

export const ScrollableAreaTab = React.forwardRef<
  HTMLDivElement,
  ScrollableAreaTabProps & React.HTMLProps<HTMLDivElement>
>(({ hasActions = false, scrollDataTest, children }, ref) => {
  const classes = useStyles({ hasActions });

  return (
    <>
      <div data-test={scrollDataTest} className={classes.activityList} ref={ref}>
        {children}
      </div>
    </>
  );
});

export const ScrollableAreaTabSkeleton: React.FC<ScrollableAreaTabProps> = ({
  hasActions = false,
}) => {
  const classes = useStyles({ hasActions });
  return (
    <div className={classes.skeleton}>
      <Skeleton variant="text" height={118} />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
      <br />
      <Skeleton variant="text" height={118} />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
    </div>
  );
};
